import { useLayoutEffect, useRef, useState } from 'react';
export function useElementWidth() {
    const ref = useRef(null);
    const [width, setWidth] = useState(0);
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        const ro = new ResizeObserver(([entry]) => {
            setWidth(entry.contentRect.width);
        });
        ro.observe(el);
        setWidth(el.getBoundingClientRect().width); // initial value
        return () => ro.disconnect();
    }, []);
    return [ref, width];
}
//# sourceMappingURL=useElementWidth.js.map